import type React from 'react';
import { useTranslation } from 'react-i18next';

import Column from '../Column';
import NumberDifference from '../NumberDifference';

export interface DiffColumnProps {
  diffs: (number | null)[];
}
const DiffColumn: React.FC<DiffColumnProps> = ({ diffs }) => {
  const { t } = useTranslation('dashboard');

  return (
    <Column
      header={
        <div className="diff-column__header">
          {t('Labels.DiffToLastYearAsterix')}
        </div>
      }
      data={diffs.map((diff, i) => (
        <NumberDifference comparisonDiff={diff} key={i} />
      ))}
    />
  );
};

export default DiffColumn;
